import {createSlice, createSelector, createAction} from '@reduxjs/toolkit'

export const initialState = {
  data: [],
  responseData: {},
  isAuthenticating: false,
  hasDirtyForm: false,
  routerPrompt: {
    isForcedOpen: false,
  },
}

export const SLICE_NAME = 'user'

export const userSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    requestLogin(state) {
      state.isAuthenticating = true
      state.responseData = {}
    },
    requestLoginFailure(state) {
      state.isAuthenticating = false
    },
    setUserToken(state, action) {
      state.isAuthenticating = false
      state.responseData = action.payload
    },
    logoutSuccess(state) {
      state.responseData = {}
    },
    cleanDirtyForm(state) {
      state.hasDirtyForm = false
    },
    setDirtyForm(state, action) {
      state.hasDirtyForm = action.payload
    },
    setRouterPrompt(state, {payload}) {
      state.routerPrompt.isForcedOpen = !!payload?.isOpen
    },
  },
})

// Selectors
const authenticating = state => state.user.isAuthenticating
const dirtyForm = state => state.user.hasDirtyForm
const isForcedToOpenPrompt = state => state.user.routerPrompt.isForcedOpen

export const isValidating = createSelector(authenticating, state => state)
export const isDirtyFormSelector = createSelector(dirtyForm, state => state)
export const isOpenRouterPrompt = createSelector(isForcedToOpenPrompt, state => state)

// Action creators are generated for each case reducer function
export const logout = createAction('user/logout')
export const beforeLogout = createAction('user/beforeLogout')
export const signOut = createAction('user/signOut')
export const onClickOkPrompt = createAction('user/onClickOkPrompt')
export const onClickCancelPrompt = createAction('user/onClickCancelPrompt')

export const {
  setUserToken,
  requestLogin,
  requestLoginFailure,
  cleanDirtyForm,
  setDirtyForm,
  logoutSuccess,
  setRouterPrompt,
} = userSlice.actions

export default userSlice.reducer
